import { cn, initials } from "@/lib/utils";
import { accentGradient, type Accent } from "./Cover";
import { PhotoFallback } from "./PhotoFallback";

export function Avatar({
  name,
  accent = "burgundy",
  className,
  size = "md",
  photo,
}: {
  name: string;
  accent?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  photo?: string;
}) {
  const key = (accent in accentGradient ? accent : "burgundy") as Accent;
  const sizes = {
    sm: "h-10 w-10 text-sm",
    md: "h-12 w-12 text-base",
    lg: "h-16 w-16 text-xl",
  };
  return (
    <div
      className={cn(
        "relative isolate flex shrink-0 items-center justify-center overflow-hidden rounded-full font-display font-semibold text-white ring-2 ring-white/60",
        photo ? "bg-white" : cn("bg-gradient-to-br", accentGradient[key]),
        sizes[size],
        className
      )}
      aria-hidden
    >
      {photo ? (
        <PhotoFallback src={photo} name={name} sizes="64px" textClassName="" />
      ) : (
        <>
          <div className="absolute inset-0 bg-[radial-gradient(120%_80%_at_20%_0%,rgba(255,255,255,0.28),transparent_60%)]" />
          <span className="relative">{initials(name)}</span>
        </>
      )}
    </div>
  );
}
